<template>
  <div>
    <v-snackbar v-model="showsnackbar" color="#182444" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: white">
            {{ msg }}
          </span>
        </v-flex>

        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #000">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-img height="100vh" src="./../assets/pic3.jpg" class="align-center">
      <v-layout wrap justify-center>
        <v-flex xs3 align-self-center>
          <!-- <v-card color="rgba(255,255,255,0.4)" class="pa-4" tile> -->
         
          <v-card tile flat height="350px">
                <v-layout wrap justify-center v-if="show == false" fill-height>
                  <v-flex px-8 py-6>
                    <v-layout wrap justify-center>
                      <v-flex xs12>
                        <span
                          style="
                            font-family: RMedium;
                            font-size: 15px;
                            color: #b8b8b8;
                          "
                        >
                          Welcome to
                        </span>
                      </v-flex>
                      <v-flex xs12 py-4 style="cursor: pointer">
                        <router-link to="/">
                          <span
                            style="
                              font-family: RBold;
                              font-size: 25px;
                              cursor: pointer;
                              color: #182444;
                            "
                          >
                          Chanakya
                          </span>
                        </router-link>
                      </v-flex>
                      <v-flex xs12>
                        <v-layout wrap justify-center>
                          <v-flex xs6 lg4 px-2>
                            <span
                              style="
                                font-family: RMedium;
                                font-size: 15px;
                                color: #000;
                              "
                            >
                              Log In
                            </span>
                            <v-progress-linear
                              height="2"
                              value="100"
                              color="#182444"
                            ></v-progress-linear>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex pt-8 xs12 text-left>
                        <v-layout wrap justify-center>
                          <v-flex xs12 pb-2>
                            <span
                              style="
                                font-family: ;
                                font-size: 12px;
                                color: #ababab;
                              "
                            >
                              Phone
                            </span>
                          </v-flex>
                          <v-flex xs12>
                            <!-- <v-form @submit.prevent="validateInput"> -->
                              <v-text-field
                  color="#182444"
                  label="Phone Number"
                  type="number"
                  :rules="phoneRules"
                  flat
                  outlined
                  dense
                  v-model="customerNum"
                  hide-details="auto"
                  class="custom-validation-field"
                >
                </v-text-field>
                            <!-- </v-form> -->
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 py-6>
                        <v-btn
                          block
                          tile
                          color="#182444"
                          light
                          :ripple="false"
                          depressed
                          @click="customerlogin"
                          class="title1"
                        >
                         <span style="color:#FFFFFF"> Continue</span>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout v-if="show == true" wrap justify-center fill-height>
                  <v-flex xs12 pt-4 align-self-baseline>
                        <span
                          style="
                            font-family: RMedium;
                            font-size: 16px;
                            color: #b8b8b8;
                          "
                        >
                          Welcome to
                        </span>
                      </v-flex>
                      <v-flex xs12 pt-2 pb-4 style="cursor: pointer">
                        <router-link to="/">
                          <span
                            style="
                              font-family: RBold;
                              font-size: 25px;
                              cursor: pointer;
                              color: #182444;
                            "
                          >
                          Chanakya
                          </span>
                        </router-link>
                      </v-flex>
                      <v-flex xs12>
                        <v-layout wrap justify-center>
                          <v-flex xs6 lg4 px-2>
                            <span
                              style="
                                font-family: RMedium;
                                font-size: 15px;
                                color: #000;
                              "
                            >
                            Verify Phone
                            </span>
                            <v-progress-linear
                              height="2"
                              value="100"
                              color="#182444"
                            ></v-progress-linear>
                          </v-flex>
                        </v-layout>
                      </v-flex>
              <!-- <v-flex xs12 class="PB" v-if="show == true"> Verify Phone</v-flex> -->
              <v-flex pt-2 xs12 class="PL medium2" v-if="show == true">
                Code is sent to +91{{ customerNum }}</v-flex
              >
              <v-flex
                xs9
                sm7
                md9
                lg8
                pt-2
                pb-3
                pl-1
                pl-sm-0
                v-if="show == true"
              >
                <v-otp-input
                  input-classes="otp-input"
                  :numInputs="4"
                  :length="4"
                  v-model="otpnum"
                  separator
                  :shouldAutoFocus="true"
                  @change="validateOTP(otpnum)"
                />
                <!-- @on-complete="validateOTP" -->
              </v-flex>
              <v-flex xs12>
                <v-flex xs12 v-if="show == true">
                  <span
                    v-if="!otpexpired"
                    style="
                      font-family: RLight;
                      font-size: 13px;
                      color: #515151;
                    "
                  >
                    Waiting for OTP... {{ timeLeft }} sec
                  </span>
                  <span
                    v-if="otpexpired"
                    style="
                      font-family: poplight;
                      font-size: 13px;
                      color: #515151;
                      cursor: pointer;
                    "
                    @click="sentOTP"
                  >
                    Resend OTP
                  </span>
                </v-flex>

                <v-btn
                  v-if="show == false && userForm == false"
                  width="100%"
                  tile
                  dark
                  color="#FEBD08"
                  @click="customerlogin"
                  >Continue
                </v-btn>
              </v-flex>
            </v-layout>
              </v-card>
        </v-flex>
      </v-layout>
    </v-img>
  </div>
</template>
<script>
import axios from "axios";
import store from "./../store";
export default {
  data() {
    return {
      rules: {
        length: (v) => (v && v.length == 10) || "Number must be  10 digits",
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      phoneRules: [
        (v) => !!v || "phone is required",
        (v) => (v && v.length <= 10) || "invalid number",
        (v) => (v && v.length >= 10) || "invalid number",
        (v) => /^\d{10}$/.test(v) || "phone number must be a number",
      ],
      customerNum: null,
      showsnackbar: false,
      timeout: 2000,
      msg: "",
      show: false,
      timeLeft: "00:00",
      intervalTimer: null,
      otpexpired: false,
      otp: null,
      email: null,
      password: null,
      userForm: false,
      Fname: null,
      Lname: null,
      showPassword: false,
      sellerform: false,
      otpnum: "",
    };
  },
  mounted() {
    this.setTime(180);
  },
  methods: {
    customerlogin() {
      // if (this.$refs.form.validate()) {
      axios({
        method: "get",
        url: "/user/send/otp",
        params: {
          phone: this.customerNum,
        },
      }).then((response) => {
        if (response.data.status) {
          if (response.data.alreadyExists == false) {
            this.userForm = true;
          }
          if (response.data.alreadyExists == true) {
            this.show = true;
          }
        } else {
          this.msg = response.data.msg;
          this.showsnackbar = true;
          location.reload();
        }
      });
      // }
    },
    uploadLoginData() {
      console.log("2 called");
      // if (this.$refs.form.validate()) {
      axios({
        method: "POST",
        url: "/user/login",
        data: {
          phone: this.customerNum,
          otp: this.otpnum,
        },
      }).then((response) => {
        if (response.data.status==true) {
          localStorage.setItem("role", response.data.data.mainRole.roles);
          localStorage.setItem("token", response.data.data.token);
          localStorage.setItem("id", response.data.data._id);
          store.commit("loginUser", response.data.data.token);
          store.commit("userData", response.data.data);
          store.commit("userType", response.data.data.mainRole.roles);
          this.userinfo();
        } else {
          this.msg = response.data.msg;
          this.showsnackbar = true;
          location.reload();
        }
      });
      // }
    },
    userinfo() {
      axios({
        method: "GET",
        url: "/user/info",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          id: localStorage.getItem("id"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            console.log("1111");
            this.$store.commit("menu", response.data.menus);
            console.log("1112");
          } else {
            console.log("router");
            store.commit("sessionOut", true);
            return;
          }
        })
        .catch((err) => {
          var msg = err;
          console.log(msg);
          // store.commit("sessionOut", true);
        });
    },

    //time out methods
    validateOTP(value) {
      console.log("1=", this.otp);
      this.otp = value;
      this.uploadLoginData();
    },

    setTime(seconds) {
      clearInterval(this.intervalTimer);
      this.timer(seconds);
    },
    timer(seconds) {
      const now = Date.now();
      const end = now + seconds * 1000;
      this.displayTimeLeft(seconds);
      this.countdown(end);
    },
    countdown(end) {
      this.intervalTimer = setInterval(() => {
        const secondsLeft = Math.round((end - Date.now()) / 1000);
        if (secondsLeft == 0) this.otpexpired = true;
        if (secondsLeft < 0) {
          clearInterval(this.intervalTimer);
          return;
        }
        this.displayTimeLeft(secondsLeft);
      }, 1000);
    },
    displayTimeLeft(secondsLeft) {
      const minutes = Math.floor((secondsLeft % 3600) / 60);
      const seconds = secondsLeft % 60;
      var seconds1 = seconds;
      if (seconds < 10) seconds1 = "0" + seconds;
      this.timeLeft = "0" + minutes + " : " + seconds1;
      // this.timeLeft = seconds1;
    },
  },
};
</script>
<style scoped>
.custom-validation-field .v-messages__message {
  color: blue!important;
}
</style>
